import feathersClient from "../../feathers/feathers-client";

export default {
  namespaced: true,

  state: {
    events: {
      Login: "Login from auth",
      "App Connect": "Reconnected to app",
      Logout: "Manual app logout",
      "Enable DND": "Do not disturb enabled",
      "Disabled DND": "Do no disturb disabled",
      "Queue Login": "Logged into Queue ${name} (${queueId})",
      "Queue Logout": "Logged out of queue ${name} (${queueId})",
      "Queue Pause": "Paused in queue ${name} (${id})",
      "Queue Unpause": "Unpaused in queue ${name} (${id})",
      "Enabled Softphone": "Softphone toggled on",
      "Disabled Softphone": "Softphone toggled off",
      "Outbound Call": "Outbound call attempt from softphone ${number}",
      "Accept Call": "Accepted softphone call ${number}",
      "Reject Call": "Softphone call declined ${number}",
      "Network Test": "Network test requested",
      "Update Timezone": "Timezone updated to ${timezone}",
      "Enable Call Push Notifications":
        "Softphone desktop push notifications enabled",
      "Disable Call Push Notifications":
        "Softphone desktop push notifications disabled",
      "Enable Extension Forwarding": "Extension forwarded to ${number}",
      "Disable Extension Forwarding": "Extension forwarding disabled",
      "Password Reset": "${type} password reset", // type = ['Manual' | 'Forgot']
      "Forgot Password": "Forgot password request",
      Coach: "Coach initiated on extension ${extension}",
      Listen: "Listen initiated on extension ${extension}",
      "Admin Disable DND": "Disabled DND for extension ${extension}",
      "Admin Queue Login": "Logged ${agentName} into ${queueName} (${queueId})",
      "Admin Queue Logout":
        "Logged ${agentName} out of ${queueName} (${queueId})",
      "Admin Queue Pause": "Paused ${agentName} in ${queueName} (${queueId})",
      "Admin Queue Unpause":
        "Unpaused ${agentName} in ${queueName} (${queueId})",
      "Sent Fax": "Sent a fax to ${destNumber}"
    }
  },

  actions: {
    create({state, rootState}, payload) {
      const {event} = payload;

      if (!event) {
        return;
      }

      let eventDescription = state.events[event];

      if (!eventDescription) {
        return;
      }

      const {id: userId, myExtension, email: userEmail, tenantId} = rootState.auth.user;
      const {name: extName, peerName} = myExtension;

      for (let key of Object.keys(payload)) {
        if (key === "event") {
          continue;
        }

        if (payload[key]) {
          eventDescription = eventDescription.replace(
            new RegExp(`\\$\\{${key}\\}`, "g"),
            payload[key]
          );
        }
      }

      const data = {
        userId,
        userEmail,
        tenantId,
        extName,
        peerName,
        event,
        eventDescription
      };

      feathersClient
        .service("user-events")
        .create(data)
        .catch(() => {
          //
        });
    }
  }
};
